import * as constants from './pipelines.constants';

const initialState = {
  pipelines: [],
  isLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.action.PIPELINES_LOADING:
      return { ...state, isLoading: true };

    case constants.action.PIPELINES_LOADED:
      return { ...state, isLoading: false };

    case constants.action.PIPELINES_FETCHED:
      return { ...state, pipelines: action.payload };

    default:
      return state;
  }
}
